webpackJsonp([0],{

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_index_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58037eb5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(57);
function injectStyle (ssrContext) {
  __webpack_require__(54)
}
var normalizeComponent = __webpack_require__(10)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58037eb5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_index_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58037eb5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(55);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(53)("eb3c9e46", content, true);

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(52)(true);
// imports


// module
exports.push([module.i, ".text-container[data-v-58037eb5]{width:100%;height:80px;line-height:20px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical;margin-bottom:10px}", "", {"version":3,"sources":["D:/xampp/htdocs/portal/portal_ssr/src/components/index.vue"],"names":[],"mappings":"AACA,iCACE,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,uBAAwB,AACxB,oBAAqB,AACrB,qBAAsB,AACtB,4BAA6B,AAC7B,kBAAoB,CACrB","file":"index.vue","sourcesContent":["\n.text-container[data-v-58037eb5] {\r\n  width: 100%;           /* Set a fixed width (adjust as needed) */\r\n  height: 80px;           /* Height = line-height * number of lines */\r\n  line-height: 20px;      /* Height of each line */\r\n  overflow: hidden;       /* Hide overflow text */\r\n  text-overflow: ellipsis; /* Optionally, show ellipsis (...) at the end */\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 4;  /* Number of lines you want to display */\r\n  -webkit-box-orient: vertical;\r\n  margin-bottom: 10px;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_services_js__ = __webpack_require__(12);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'portal',
  data: function data() {
    return {
      menu_list: [],
      menu_all: [],
      sortData: 0,
      bt_sort: 0,
      req_status: 0,
      sort_status: 4
    };
  },

  methods: {
    GO_to: function GO_to(detail) {
      var _this = this;

      var obj = { data: { id: detail.app_id } };
      __WEBPACK_IMPORTED_MODULE_1__service_services_js__["a" /* default */].update_portal(this.URL_API, obj, function (result) {
        _this.getWeb();
      }, function (error) {
        alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    sort_active: function sort_active(index) {
      if (this.key_search != '') {
        this.key_search = '';
      }
      this.bt_sort = index;
      if (index < 4) {
        this.filter(index);
      }
      this.sort_status = 4;
      this.sortedList(this.sort_status);
    },
    search: function search(keyword) {
      this.bt_sort = 0;
      this.getWeb(this.bt_sort);
    },
    sortedList: function sortedList(key) {
      // alert(key)
      switch (parseInt(key)) {
        case 4:
          return this.menu_list.sort(function (a, b) {
            return a.app_name > b.app_name;
          });
          break;
        case 5:
          return this.menu_list.sort(function (a, b) {
            return a.app_name < b.app_name;
          });
          break;
        case 6:
          return this.menu_list.sort(function (a, b) {
            return b.app_count - a.app_count;
          });
      }
    },
    filter: function filter(key) {
      switch (parseInt(key)) {
        case 0:
          this.key_search = '';this.filter_all(); // this.getWeb(this.bt_sort)
          break;
        case 1:
          this.menu_list = this.menu_all;this.filter_teacher();
          break;
        case 2:
          this.menu_list = this.menu_all;this.filter_personnel();
          break;
        case 3:
          this.menu_list = this.menu_all;this.filter_student();
      }
    },
    filter_all: function filter_all() {
      this.menu_list.forEach(function (val, key) {
        val['show'] = 1;
      }.bind(this));
    },
    filter_teacher: function filter_teacher() {
      this.menu_list.forEach(function (val, key) {
        if (val['teacher_type'] == 1) {
          val['show'] = 1;
        } else {
          val['show'] = 0;
        }
      }.bind(this));
    },
    filter_personnel: function filter_personnel() {
      this.menu_list.forEach(function (val, key) {
        if (val['personnel_type'] == 1) {
          val['show'] = 1;
        } else {
          val['show'] = 0;
        }
      }.bind(this));
    },
    filter_student: function filter_student() {
      this.menu_list.forEach(function (val, key) {
        if (val['student_type'] == 1) {
          val['show'] = 1;
        } else {
          val['show'] = 0;
        }
      }.bind(this));
    }
  },
  computed: {
    listFilter: function listFilter() {
      var text = this.key_search.trim();
      return this.menu_list.filter(function (item) {
        return item.app_name.indexOf(text) > -1 || item.app_link.indexOf(text) > -1 || item.app_discription.indexOf(text) > -1;
      });
    }
  },
  mounted: function mounted() {
    this.getWeb(this.bt_sort);
    var contianer = document.getElementsByClassName('contianer');
    for (var i = 0; i < contianer.length; i++) {
      contianer[i].style.height = screen.availHeight + 'px';
    }
    document.getElementById("team").style.display = "block";
  }
});

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portal"},[_c('div',{staticClass:"container",staticStyle:{"padding-top":"1%"}},[_c('div',{staticClass:"tabs"},[_c('ul',[_c('li',{class:{ 'is-active': _vm.bt_sort==0 },on:{"click":function($event){_vm.sort_active(0);}}},[_vm._m(0,false,false)]),_vm._v(" "),_c('li',{class:{ 'is-active': _vm.bt_sort==1 },on:{"click":function($event){_vm.sort_active(1);}}},[_vm._m(1,false,false)]),_vm._v(" "),_c('li',{class:{ 'is-active': _vm.bt_sort==2 },on:{"click":function($event){_vm.sort_active(2);}}},[_vm._m(2,false,false)]),_vm._v(" "),_c('li',{class:{ 'is-active': _vm.bt_sort==3 },on:{"click":function($event){_vm.sort_active(3);}}},[_vm._m(3,false,false)]),_vm._v(" "),_vm._m(4,false,false),_vm._v(" "),_c('li',{attrs:{"id":"sort2"}},[_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sort_status),expression:"sort_status"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sort_status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.sortedList(_vm.sort_status)}]}},[_c('option',{attrs:{"value":"4"}},[_vm._v("A -Z")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Z -A")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("POPPULA")])])])])])]),_vm._v(" "),_c('div',{staticClass:"field has-addons",attrs:{"id":"search_portal"}},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.key_search),expression:"key_search"}],staticClass:"input",attrs:{"type":"text","placeholder":"กรอกคำค้น..."},domProps:{"value":(_vm.key_search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.key_search=$event.target.value}}}),_vm._v(" "),_vm._m(5,false,false)])])])])]),_vm._v(" "),_c('div',{staticClass:"show-content"},_vm._l((_vm.listFilter),function(menus,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(menus.show == 1),expression:"menus.show == 1"}],key:menus.app_name,staticClass:"box"},[_c('article',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('figure',{staticClass:"image is-96x96"},[_c('a',{attrs:{"href":menus.app_link,"target":"_blank"},on:{"click":function($event){_vm.GO_to(menus)}}},[_c('img',{attrs:{"src":menus.app_icon_path + menus.app_icon,"alt":"Image","onerror":"this.src = './static/noneimage.png'"}})])]),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered",staticStyle:{"margin-top":"5%"}},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v("View")]),_vm._v(" "),_c('p',{staticClass:"title",staticStyle:{"font-size":"24px"}},[_vm._v(" "+_vm._s(_vm.money_format(menus.app_count))+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"media-content"},[_c('div',{staticClass:"content"},[_c('a',{attrs:{"href":menus.app_link,"target":"_blank"},on:{"click":function($event){_vm.GO_to(menus)}}},[_c('b',{staticClass:"head"},[_vm._v(_vm._s(menus.app_name))]),_vm._v(" "),_c('div',{staticClass:"body  text-container",staticStyle:{"color":"#5a5a5a"}},[_vm._v("\n                        "+_vm._s(menus.app_discription)+"\n                      ")])])]),_vm._v(" "),(menus.app_manual)?_c('a',{staticStyle:{"color":"#2e2e30","z-index":"999"},attrs:{"href":menus.app_manual,"target":"_blank"}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" คู่มือการใช้งาน")]):_vm._e()])])])}))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-star"})]),_vm._v(" "),_c('span',[_vm._v("ทั้งหมด")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-user"})]),_vm._v(" "),_c('span',[_vm._v("อาจารย์")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-users"})]),_vm._v(" "),_c('span',[_vm._v("บุคลากร")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-graduation-cap"})]),_vm._v(" "),_c('span',[_vm._v("นักศึกษา")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{attrs:{"id":"sort1"}},[_c('div',{staticClass:"field-label is-normal",attrs:{"id":"sort_title"}},[_c('label',{staticClass:"label",staticStyle:{"font-weight":"bold"}},[_vm._v(" Sort By : ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.e0f362d22a23a740a09e.js